const info = {
    $schema: '../chain.schema.json',
    chain_name: 'arkh',
    status: 'live',
    network_type: 'mainnet',
    website: 'https://arkhadian.com/',
    pretty_name: 'Arkhadian',
    chain_type: 'cosmos',
    chain_id: 'arkh',
    bech32_prefix: 'arkh',
    daemon_name: 'arkhd',
    node_home: '$HOME/.arkh',
    key_algos: ['secp256k1'],
    slip44: 118,
    fees: {
        fee_tokens: [{
                denom: 'arkh',
                fixed_min_gas_price: 0.01,
                low_gas_price: 0.01,
                average_gas_price: 0.025,
                high_gas_price: 0.03
            }]
    },
    staking: {
        staking_tokens: [{
                denom: 'arkh'
            }]
    },
    codebase: {
        git_repo: 'https://github.com/vincadian/arkh-blockchain',
        recommended_version: 'v2.0.0',
        compatible_versions: ['v2.0.0'],
        binaries: {
            "linux/amd64": 'https://github.com/vincadian/arkh-blockchain/releases/download/latest/arkh-blockchain_latest_linux_amd64.tar.gz',
            "darwin/amd64": 'https://github.com/vincadian/arkh-blockchain/releases/download/latest/arkh-blockchain_latest_darwin_amd64.tar.gz'
        },
        genesis: {
            genesis_url: 'https://raw.githubusercontent.com/vincadian/arkh-blockchain/master/genesis/genesis.json'
        }
    },
    logo_URIs: {
        png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/arkh/images/arkh.png',
        svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/arkh/images/arkh.svg'
    },
    apis: {
        rpc: [{
                address: 'https://arkhadian-mainnet-rpc.bonynode.online/',
                provider: 'arkhnetwork'
            }],
        rest: [{
                address: 'https://arkhadian-mainnet-api.bonynode.online/',
                provider: 'arkhnetwork'
            }],
        grpc: [{
                address: 'https://arkhadian-mainnet-grpc.bonynode.online/',
                provider: 'arkhnetwork'
            }]
    },
    explorers: [{
            kind: 'BonyNode Explorer',
            url: 'https://explorer.bonynode.online/arkhadian',
            tx_page: 'https://explorer.bonynode.online/arkhadian/tx/${txHash}'
        }],
    images: [{
            png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/arkh/images/arkh.png',
            svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/arkh/images/arkh.svg',
            theme: {
                primary_color_hex: '#bdbb82'
            }
        }]
};
export default info;
